import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, firebaseReady } from '../firebase';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import './Admin.css';

/**
 * AdminApp
 * Gate for the /admin route. Visitors on the public site are signed in
 * anonymously (see SupportWidget); that never satisfies this gate.
 * Only a real Firebase Auth user signed in with email/password (created
 * for your support staff in the Firebase console -> Authentication)
 * gets past AdminLogin into the dashboard.
 */
export default function AdminApp() {
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!firebaseReady) {
      setChecked(true);
      return undefined;
    }
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u && !u.isAnonymous ? u : null);
      setChecked(true);
    });
    return () => unsub();
  }, []);

  if (!firebaseReady) {
    return (
      <div className="admin-notice">
        <p>Firebase isn&apos;t configured yet.</p>
        <p>Copy .env.example to .env.local, fill in your project config, and restart.</p>
      </div>
    );
  }

  if (!checked) return null;

  return user ? <AdminDashboard user={user} /> : <AdminLogin />;
}